import DatePicker, { registerLocale } from "react-datepicker";
import { useStyles } from "./DateRange.styles";
import { useTranslation } from "react-i18next";
import es from "date-fns/locale/es";
import { IDateRange } from "./DateRangeInterfaces";
import { Typography, Tooltip } from "@mui/material";
registerLocale("es", es);

const DateRange = ({ startDate, endDate, onChange, label, placeholderText, className, hideTooltip }: IDateRange) => {
    const classes = useStyles();
    const { i18n, t } = useTranslation();
    return (
        <Tooltip
            placement="top"
            PopperProps={{
                className: classes.tooltip,
            }}
            open={(!startDate || !endDate) && !hideTooltip}
            title={
                <Typography className={classes.tooltipTexts}>
                    {t("locations.summary_report.filters.select_a_valid_date_range")}
                </Typography>
            }
        >
            <div className={`${classes.datePickersWrapper} ${className ? className : ""}`}>
                {!!label && <div className={classes.label}>{label}</div>}
                <DatePicker
                    locale={i18n.language.slice(0, 2)}
                    className={classes.datePicker}
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    placeholderText={placeholderText}
                    onChange={onChange}
                    withPortal
                />
            </div>
        </Tooltip>
    );
};

export default DateRange;
